<template>
    <BreadCrumb PageTitle="Liste des sorties" />
    <ListeSortie />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeSortie from "../../components/Sortie/ListeSortie.vue";

    export default defineComponent({
        name: "ListeSortiePage",
        components: {
            BreadCrumb,
            ListeSortie,
        },
    });
</script>